/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CspUsersRoleFilter } from './cspUsersRoleFilter';
import { CspUserDetails } from './cspUserDetails';
import { CspUsersSearchCriteria } from './cspUsersSearchCriteria';


export interface CspUsersResponse { 
    /**
     * Organization ID
     */
    orgId: string;
    /**
     * Total number of users matching the criteria
     */
    totalUsers: number;
    roleFilter?: CspUsersRoleFilter;
    searchCriteria?: CspUsersSearchCriteria;
    /**
     * User details (only when countOnly=false)
     */
    users?: Array<CspUserDetails>;
}

